/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // POWERPAY discount price updater
  function updatePowerPayPrices() {
    const productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // Get the selected variant data from the product JSON
    const productJson = productSection.querySelector('[data-product-json]');
    if (!productJson) return;

    try {
      const product = JSON.parse(productJson.textContent);
      
      // Get the selected variant ID from the form
      const variantInput = productSection.querySelector('[name="id"]');
      if (!variantInput) return;
      
      const selectedVariantId = parseInt(variantInput.value);
      const selectedVariant = product.variants.find(v => v.id === selectedVariantId);
      
      if (!selectedVariant) return;

      const variantPrice = selectedVariant.price;
      
      // Find all price wrappers
      const priceWrappers = productSection.querySelectorAll('[data-price-wrapper]');
      
      priceWrappers.forEach(wrapper => {
        const powerpayContainer = wrapper.querySelector('.product__powerpay-discount');
        const regularPriceEl = wrapper.querySelector('[data-product-price]');
        const comparePriceEl = wrapper.querySelector('[data-compare-price]');
        
        // Get configurable values from data attributes
        const powerpayDiscount = parseInt(wrapper.getAttribute('data-powerpay-discount')) || 8000;
        const minPrice = parseInt(wrapper.getAttribute('data-powerpay-min-price')) || 39900;
        
        // If POWERPAY container exists, this block has the feature enabled
        if (powerpayContainer) {
          if (variantPrice >= minPrice) {
            // Show POWERPAY prices, hide regular price
            powerpayContainer.style.display = 'block';
            if (regularPriceEl) regularPriceEl.style.display = 'none';
            if (comparePriceEl) comparePriceEl.style.display = 'none';
            
            const normalPriceEl = powerpayContainer.querySelector('[data-product-price-powerpay-normal]');
            const discountPriceEl = powerpayContainer.querySelector('[data-product-price-powerpay-discount]');
            const comparePricePowerpayEl = powerpayContainer.querySelector('[data-compare-price-powerpay]');
            
            if (normalPriceEl && discountPriceEl && window.Shopify && window.Shopify.formatMoney) {
              const powerpayPrice = variantPrice - powerpayDiscount;
              normalPriceEl.textContent = window.Shopify.formatMoney(variantPrice, theme.moneyFormat || '{{amount}}');
              discountPriceEl.textContent = window.Shopify.formatMoney(powerpayPrice, theme.moneyFormat || '{{amount}}');
              
              // Update compare at price for POWERPAY section
              if (comparePricePowerpayEl) {
                if (selectedVariant.compare_at_price > variantPrice) {
                  comparePricePowerpayEl.style.display = '';
                  comparePricePowerpayEl.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price, theme.moneyFormat || '{{amount}}');
                } else {
                  comparePricePowerpayEl.style.display = 'none';
                }
              }
            }
          } else {
            // Hide POWERPAY prices, show regular price
            powerpayContainer.style.display = 'none';
            if (regularPriceEl) regularPriceEl.style.display = '';
            if (comparePriceEl && selectedVariant.compare_at_price > variantPrice) {
              comparePriceEl.style.display = '';
            }
          }
        }
      });
    } catch (e) {
      console.error('Error updating POWERPAY prices:', e);
    }
  }

  // Update POWERPAY prices when the page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePowerPayPrices);
  } else {
    updatePowerPayPrices();
  }

  // Update POWERPAY prices when variant changes
  // Listen for variant input changes
  document.addEventListener('change', function(e) {
    if (e.target && e.target.name === 'id' && e.target.form && e.target.form.querySelector('[data-product-form]')) {
      setTimeout(updatePowerPayPrices, 100);
    }
  });

  // Also listen for clicks on variant options (swatches, buttons, etc.)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-option-value]') || e.target.closest('[data-popout-option]')) {
      setTimeout(updatePowerPayPrices, 100);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
